import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=346aad83&"
import script from "./DataTableFooter.vue?vue&type=script&lang=js&"
export * from "./DataTableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports